import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";

const CurrencyLabelStyled = styled("span")(({ fontSize, fontWeight, color }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "2px",
  fontSize: fontSize || "14px",
  fontWeight: fontWeight || 400,
  lineHeight: "18px",
  color: color || "#0E0E0E",
}));

const CurrencyIcon = ({ width = 14, height = 14, color = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33665 2.11908C1.34131 2.12607 1.36694 2.15754 1.3914 2.18785C1.56967 2.4 1.70365 2.74503 1.77589 3.17981C1.82366 3.46539 1.82599 3.55514 1.82599 4.64385V5.65795H1.33898C0.893907 5.65795 0.842643 5.65562 0.75526 5.63813C0.617778 5.60899 0.475636 5.5309 0.380098 5.43065C0.304366 5.35022 0.306696 5.34556 0.311357 5.58918C0.317182 5.79083 0.319512 5.81298 0.34864 5.92255C0.395244 6.09623 0.459324 6.22562 0.556028 6.34101C0.687684 6.49954 0.821671 6.58813 1.01275 6.64758C1.05353 6.65923 1.13974 6.6639 1.445 6.66623L1.82599 6.67205V7.17677V7.68266L1.28888 7.67916L0.749435 7.67567L0.656226 7.63837C0.545542 7.59407 0.495443 7.56143 0.387088 7.46469L0.307861 7.39358L0.312522 7.61622C0.318347 7.82254 0.319512 7.84585 0.34864 7.95076C0.450004 8.32143 0.694675 8.58603 1.01741 8.67229C1.0978 8.69443 1.12926 8.6956 1.46597 8.70026L1.82599 8.70492V9.74933C1.82599 10.3799 1.82249 10.845 1.81667 10.9243C1.81084 10.9966 1.7922 11.1318 1.77589 11.2262C1.70016 11.661 1.56384 11.9885 1.3681 12.2007L1.32849 12.2438H3.29867C4.47659 12.2438 5.35741 12.2391 5.48673 12.2333C5.71393 12.2217 6.22075 12.1715 6.33493 12.147C6.37105 12.1401 6.43862 12.1296 6.48289 12.1226C6.57727 12.1086 6.73339 12.0759 6.95826 12.0188C7.27516 11.9396 7.56411 11.8405 7.84723 11.7146C7.93578 11.675 8.18977 11.5456 8.25734 11.5048C8.29346 11.4838 8.33657 11.4582 8.35288 11.45C8.39832 11.4255 8.47405 11.3766 8.58474 11.2973C8.6395 11.2577 8.69426 11.2192 8.70591 11.211C8.75484 11.1784 8.92378 11.0374 9.00068 10.9663C9.29312 10.697 9.53779 10.3974 9.7277 10.0769C9.7545 10.0303 9.78945 9.97197 9.8046 9.94749C9.84304 9.88222 10.0015 9.55584 10.0166 9.50688C10.0236 9.48474 10.033 9.46142 10.0376 9.45676C10.0679 9.41713 10.2427 8.86695 10.2636 8.74689C10.2706 8.70842 10.2741 8.70259 10.3033 8.69676C10.3219 8.69327 10.5934 8.69327 10.9068 8.6956C11.5336 8.70026 11.5336 8.70026 11.6723 8.76437C11.7503 8.80051 11.7736 8.81683 11.8598 8.89492C11.9728 8.99633 11.9624 9.01265 11.9554 8.75854C11.9507 8.60934 11.9449 8.51726 11.9344 8.47996C11.8948 8.33658 11.8855 8.30628 11.8505 8.23401C11.7363 7.98456 11.5453 7.80622 11.3006 7.72113L11.205 7.68616L10.8159 7.6815L10.4279 7.67567L10.4326 7.53929C10.4372 7.35978 10.4372 7.00426 10.4314 6.82126L10.4268 6.67439L10.9464 6.67205C11.3915 6.66972 11.4742 6.67205 11.5231 6.68488C11.6699 6.72567 11.769 6.78162 11.8901 6.89236L11.9577 6.9553V6.78279C11.9577 6.57764 11.9472 6.48672 11.9053 6.3515C11.8226 6.07758 11.6594 5.87359 11.4264 5.7477C11.275 5.66611 11.2656 5.66378 10.7448 5.66028C10.4396 5.65795 10.28 5.65329 10.2718 5.64629C10.2648 5.6393 10.259 5.62764 10.259 5.61832C10.259 5.60899 10.2415 5.53556 10.2182 5.4563C9.94557 4.49231 9.43642 3.72649 8.69193 3.15883C8.59056 3.08073 8.34239 2.91637 8.2422 2.86042C8.20375 2.83828 8.1618 2.81496 8.15132 2.80797C8.10238 2.78116 7.8216 2.64361 7.75169 2.61447C7.70975 2.59582 7.65499 2.57251 7.63052 2.56319C7.21924 2.38484 6.5295 2.21583 6.00287 2.16337C5.91666 2.15521 5.80248 2.14239 5.75005 2.13773C5.51237 2.11092 5.18264 2.10742 3.31033 2.10742C1.72812 2.10742 1.33082 2.11092 1.33665 2.11908ZM5.18963 2.6238C5.58344 2.64711 5.82578 2.67742 6.1089 2.74619C6.9734 2.95134 7.58158 3.38496 8.02316 4.10999C8.06394 4.17759 8.23637 4.52961 8.262 4.60072C8.38434 4.93059 8.44376 5.12642 8.49619 5.38519C8.509 5.44814 8.52648 5.53206 8.53464 5.57169C8.54279 5.61016 8.54629 5.64629 8.54279 5.64979C8.53697 5.65445 7.36721 5.65679 5.94112 5.65562L3.34877 5.65329L3.34528 4.15545C3.34411 3.33251 3.34528 2.64828 3.34877 2.63546L3.35343 2.61331H4.18182C4.63621 2.61331 5.0906 2.61797 5.18963 2.6238ZM8.65581 6.70702C8.66396 6.75715 8.66396 7.60806 8.65581 7.65002L8.64882 7.6815L5.99821 7.67916L3.34877 7.67567L3.34644 7.18144C3.34411 6.90984 3.34644 6.68371 3.34877 6.67905C3.35227 6.67322 4.48125 6.66972 6.00171 6.66972H8.64882L8.65581 6.70702ZM8.53697 8.70842C8.54279 8.72591 8.51483 8.86928 8.45774 9.10241C8.39249 9.36467 8.30395 9.62927 8.21423 9.8251C8.16996 9.92535 8.05928 10.1422 8.03248 10.183C8.01966 10.2016 7.98238 10.261 7.94976 10.3135C7.74004 10.6422 7.44061 10.9418 7.09923 11.1633C6.97457 11.2425 6.71825 11.3777 6.6495 11.3987C6.63552 11.4022 6.62038 11.4092 6.61455 11.4139C6.60639 11.4209 6.50037 11.4605 6.37687 11.5048C6.14968 11.5852 5.71742 11.6726 5.37022 11.7088C5.14536 11.7309 5.10924 11.7321 4.24357 11.7321H3.34761V10.2203V8.70726L5.92132 8.70259C7.33691 8.70026 8.50318 8.69676 8.5125 8.69443C8.52299 8.69327 8.53347 8.70026 8.53697 8.70842Z"
      fill={color}
    />
  </svg>
);

export const CurrencyLabel = ({
  amount,
  showSymbol = true,
  symbolPosition = "left",
  fontSize,
  fontWeight,
  color,
  iconWidth,
  iconHeight,
  iconColor,
  className,
}) => {
  // Format number with commas
  const formattedAmount = typeof amount === "number" 
    ? amount.toLocaleString("en-US") 
    : amount;

  return (
    <CurrencyLabelStyled
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      className={className}
    >
      {showSymbol && symbolPosition === "left" && (
        <CurrencyIcon
          width={iconWidth}
          height={iconHeight}
          color={iconColor || color || "currentColor"}
        />
      )}
      <span>{formattedAmount}</span>
      {showSymbol && symbolPosition === "right" && (
        <CurrencyIcon
          width={iconWidth}
          height={iconHeight}
          color={iconColor || color || "currentColor"}
        />
      )}
    </CurrencyLabelStyled>
  );
};

CurrencyLabel.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  showSymbol: PropTypes.bool,
  symbolPosition: PropTypes.oneOf(["left", "right"]),
  fontSize: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  iconColor: PropTypes.string,
  className: PropTypes.string,
};
